import { Injectable } from '@angular/core';

import { PinToTaskbarService } from './pin-to-taskbar.service';

@Injectable()
export class OfficeHomePinToTaskbarService implements PinToTaskbarService {

    public async isEligibleToPin(): Promise<boolean> {
        return new Promise<boolean>(resolve => resolve(false));
    }

    public async pinToTaskbar(): Promise<boolean> {
        return new Promise<boolean>(resolve => resolve(false));
    }
}